import { Layout, Menu, Typography } from "antd";
import { useLocation, useNavigate } from "react-router-dom";
import { startTransition } from "react";

const { Sider } = Layout;
const { Text, Title } = Typography;

const AppSidebar = ({
  collapsed,
  setCollapsed,
  selectedKeys,
  setSelectedKeys,
  menuItems,
  role,
}) => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleMenuClick = ({ key }) => {
    startTransition(() => {
      navigate(`/${role}${key}`);
    });
  };

  return (
    <Sider
      trigger={null}
      collapsible
      collapsed={collapsed}
      width={280}
      collapsedWidth={80}
      breakpoint="lg"
      onBreakpoint={(broken) => {
        if (broken) {
          setCollapsed(true);
        }
      }}
      className={`
    fixed left-0 top-0 bottom-0 z-[100]
    bg-white/95 backdrop-blur-xl border-r border-white/20 shadow-[4px_0_24px_rgba(0,0,0,0.1)]
  `}
    >
      {/* Gradient background layer */}
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          height: "200px",
          background:
            "linear-gradient(135deg, rgba(4, 113, 163, 0.05) 0%, rgba(4, 113, 163, 0.02) 100%)",
          zIndex: 0,
        }}
      />

      {/* Header */}
      <div
        style={{
          padding: collapsed ? "20px 16px" : "24px 24px",
          borderBottom: "1px solid #e2e8f0",
          textAlign: collapsed ? "center" : "left",
          position: "relative",
          zIndex: 1,
          background: "rgba(255, 255, 255, 0.8)",
          backdropFilter: "blur(10px)",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: collapsed ? "center" : "flex-start",
          }}
        >
          <div
            style={{
              width: collapsed ? "32px" : "40px",
              height: collapsed ? "32px" : "40px",
              background: "linear-gradient(135deg, #0471a3 0%, #0369a1 100%)",
              borderRadius: "12px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginRight: collapsed ? 0 : "12px",
              boxShadow: "0 4px 12px rgba(4, 113, 163, 0.3)",
            }}
          >
            <Text
              style={{
                color: "white",
                fontWeight: "bold",
                fontSize: collapsed ? "14px" : "16px",
              }}
            >
              T
            </Text>
          </div>
          {!collapsed && (
            <div>
              <Title
                level={4}
                style={{
                  margin: 0,
                  color: "#0471a3",
                  fontSize: "18px",
                  fontWeight: 700,
                  letterSpacing: "-0.5px",
                }}
              >
                TTT-FINANCE
              </Title>
            </div>
          )}
        </div>
      </div>

      {/* Scrollable Menu Section */}
      <div
        style={{
          flexGrow: 1,
          position: "relative",
          zIndex: 1,
          padding: "20px 0",
          overflowY: "hidden",
          overflowX: "hidden",
        }}
      >
        <Menu
          mode="inline"
          selectedKeys={[location.pathname.replace(`/${role}`, "")]}
          inlineCollapsed={collapsed} // ← Essential
          onSelect={({ selectedKeys }) =>{
        
             setSelectedKeys(selectedKeys)
          }}
          onClick={handleMenuClick}
          style={{
            border: "none",
            background: "transparent",
          }}
          items={menuItems.map((item) => ({
            key: item.key,
            icon: (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  width: "24px",
                  height: "24px",
                }}
              >
                {item.icon}
              </div>
            ),
            label: (
              <span
                style={{
                  fontWeight: selectedKeys.includes(item.key) ? 600 : 500,
                  fontSize: "14px",
                  display: collapsed ? "none" : "inline",
                }}
              >
                {item.label}
              </span>
            ),
            style: {
              margin: collapsed ? "4px 4px" : "2px 12px",
              borderRadius: "12px",
              height: "48px",
              display: "flex",
              alignItems: "center",
              justifyContent: collapsed ? "center" : "flex-start",
              transition: "all 0.3s ease",
              backgroundColor: selectedKeys.includes(item.key)
                ? "#0077A3"
                : "transparent",
              color: selectedKeys.includes(item.key) ? "#fff" : "#000",
            },
          }))}
        />
      </div>
    </Sider>
  );
};

export default AppSidebar;
